const ShipmentsRoutes = [
	{
		path: '/shipments',
		component: () => import('@/components/default'),
		children: [
			{
				path: '',
				name: '',
				component: () => import('@/components/shipments/Shipments.vue'),
			},
			{
				path: ':id?',
				name: 'shipment-details',
				component: () => import('@/components/shipments/ShipmentDetails'),
			},
		],
	},
];

export default ShipmentsRoutes;
